import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "../../components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
  }

  componentDidMount() {
    // this.initMenu()
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      // this.initMenu()
    }
  }

  initMenu() {
    new MetisMenu("#side-menu")

    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300
          }
        }
      }
    }, 300)
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      this.scrollElement(item)
      return false
    }
    this.scrollElement(item)
    return false
  }

  // Define parent-child route relationships
  getRouteHierarchy() {
    return {
      '/stores': [
        '/merchant-details',
        '/plan-info',
        '/placement-edit',
        '/usage-charges-edit',
        '/common-setting-edit',
        '/campaign-charge-edit',
        '/blocked-coupon',
        '/upload-roster-csv',
        '/discount-type-edit',
        '/price-selector-edit',
        '/campaign-metafields-edit'
      ]
      // Add more parent-child relationships here if needed
      // '/parent-path': ['/child1', '/child2', '/grandchild']
    }
  }

  // Check if a menu item should be active based on current path
  isMenuItemActive(menuPath, currentPath, routeHierarchy) {
    // Direct match
    if (currentPath === menuPath) {
      return true
    }

    // Check if current path starts with menu path (for nested routes)
    if (currentPath.startsWith(menuPath + '/')) {
      return true
    }

    // Check if any child route matches current path
    const children = routeHierarchy[menuPath] || []
    for (const childPath of children) {
      // Direct child match
      if (currentPath === childPath) {
        return true
      }
      // Grandchild match (current path starts with child path)
      if (currentPath.startsWith(childPath + '/')) {
        return true
      }
    }

    return false
  }

  render() {
    const { location } = this.props
    const currentPath = location.pathname
    const routeHierarchy = this.getRouteHierarchy()

    const menuGroups = [
      {
        title: 'Management',
        items: [
          { path: '/dashboard', icon: 'mdi mdi-view-dashboard-outline', label: 'Home' },
          { path: '/stores', icon: 'mdi mdi-storefront-outline', label: 'Stores' },
          { path: '/uninstalled-stores', icon: 'mdi mdi-store-remove', label: 'Ex-Stores' },
          { path: '/platform', icon: 'mdi mdi-server-network', label: 'Platform' },
          { path: '/auto-bcl', icon: 'mdi mdi-robot-outline', label: 'Auto BCL' },
        ]
      },
      {
        title: 'Analytics',
        items: [
          { path: '/latest-blocked-orders', icon: 'mdi mdi-shield-check-outline', label: 'Analytics Overview' },
          { path: '/scanner-website', icon: 'mdi mdi-barcode-scan', label: 'Coupon Scanner' },
          { path: '/coupon-analyzer', icon: 'mdi mdi-chart-areaspline', label: 'Coupon Analyzer' },
        ]
      },
      {
        title: 'Configuration',
        items: [
          { path: '/reference-store', icon: 'mdi mdi-link-variant', label: 'Reference Store' },
          { path: '/client-review-list', icon: 'mdi mdi-clipboard-account-outline', label: 'Client Review List' },
          { path: '/usage-charge', icon: 'mdi mdi-cash-multiple', label: 'Usages Charge' },
          { path: '/logs', icon: 'mdi mdi-bug-outline', label: 'Error Logs' },
        ]
      },
    ]

    return (
      <React.Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
          <div id="sidebar-menu">
            {menuGroups.map((group, groupIndex) => (
              <div key={groupIndex}>
                <ul className="metismenu list-unstyled" id={groupIndex === 0 ? 'side-menu' : undefined}>
                  <li className="menu-title">{this.props.t(group.title)}</li>
                  {group.items.map((item, index) => {
                    const isActive = this.isMenuItemActive(item.path, currentPath, routeHierarchy)
                    return (
                      <li key={index} className={isActive ? 'mm-active' : ''}>
                        <Link
                          to={item.path}
                          className={`waves-effect${isActive ? ' nav-item-active' : ''}`}
                        >
                          <i className={item.icon} />
                          <span>{this.props.t(item.label)}</span>
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            ))}
          </div>
        </SimpleBar>
      </React.Fragment>
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
}

export default withRouter(withTranslation()(SidebarContent))
